export default __webpack_public_path__ + "7cc9a490a8dd2be793a7fdfd64af744c.png";